import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import React from "react";
import { useSnackbar } from "notistack";

import RegisterUser from "./RegisterUser";

const RegisterUserWithSnackbar = (props) => {
  const snackbar = useSnackbar();
  return React.createElement(RegisterUser, { ...props, ...snackbar });
};

const mapStateToProps = (_state) => ({
  // authReducer: state.auth
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RegisterUserWithSnackbar),
);
